// Side-effect barrel for the legacy form / landing-page subtree (WEB-8486).
// editLandingpageRoot.jsx creates the ReactTemplates.form namespace; the rest populate its keys
// at module eval. Loaded once by ReactTemplatesShim at the React entry (root first). Order mirrors
// the old legacy-react.js. editorElement and htmlContentType are not listed: editLandingpageRoot
// imports them directly (relative, within this directory), so they load with it.
import './editLandingpageRoot';
import './landingPageTemplate';
import './formDashboard';
import './formGraph';
import './editorBackgroundElement';
import './selectColumnContent';
import './videoContentType';
import './textContentType';
import './imageContentType';
import './formContentType';
import './countdownContentType';
import './fileContentType';
import './mapContentType';
import './editFieldRow';
import './formDashboardTopbar';
import './landingPage';
import './cardContentType';
import './buttonContentType';
import './formSelect';
import './validDomainModal';
